import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule, ToastNoAnimation, ToastNoAnimationModule  } from 'ngx-toastr';
 
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule,HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { DefaultModule } from './layout/default/default.module'; 
import { InnerpageModule } from './layout/innerpage/innerpage.module';
import { ProfileComponent } from './profile/profile.component'; 
import { DashboardComponent } from './dashboard/dashboard.component'; 
import { AuthInterceptor } from './shared/intercepter/auth.interceptor';
import { SignupComponent } from './signup/signup.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { SignupCComponent } from './signup-c/signup-c.component';
import { SignupCoachComponent } from './signup-coach/signup-coach.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { PaymentSuccessComponent } from './payment-success/payment-success.component';
import { PaymentCancelComponent } from './payment-cancel/payment-cancel.component';
import { SharedModule } from './layout/shared/shared.module';
import { InviteSignupComponent } from './invite-signup/invite-signup.component';
import { PlaylistViewComponent } from './playlist-view/playlist-view.component';
import { NgSlimScrollModule, SLIMSCROLL_DEFAULTS } from 'ngx-slimscroll';
import { ActionReducer, StoreModule, INIT, UPDATE, MetaReducer } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects'
import { AppEffect } from './store/effect/app.effect';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AppState } from './store/app.states';
import { AdminModule } from './layout/admin/admin.module';
import { SharedAdminModule } from './layout/sharedadmin/sharedadmin.module';
import { userReducer } from './store/reducers/user.reducer';
import { adminuserReducer } from './store/reducers/adminuser.reducer';
import { SchoolcoachComponent } from './schoolcoach/schoolcoach.component';
import { NgxStripeModule,StripeElementsDirective,StripeCardComponent } from 'ngx-stripe';
import { PlansComponent } from './plans/plans.component';
import { SeriespageModule } from './layout/seriespage/seriespage.module';
import { SeriesinnerModule } from './layout/seriesinner/seriesinner.module';
import { SeriesComponent } from './series/series.component';
import { SeriesviewComponent } from './seriesview/seriesview.component';



export const hydrationMetaReducer = (
  reducer: ActionReducer<AppState>
): ActionReducer<AppState> => {
  return (state, action) => {
    if (action.type === INIT || action.type === UPDATE) {
      const storageValue = localStorage.getItem("state");
      if (storageValue) {
        try {
          return JSON.parse(storageValue);
        } catch {
          localStorage.removeItem("state");
        }
      }
    }
    const nextState = reducer(state, action);
    localStorage.setItem("state", JSON.stringify(nextState));
    return nextState;
  };
};

export const metaReducers: MetaReducer[] = [hydrationMetaReducer];


@NgModule({
  declarations: [
    AppComponent,
    ProfileComponent,
    DashboardComponent,
    SignupComponent,
    SignupCComponent,
    SignupCoachComponent,
    ForgotPasswordComponent,
    PaymentSuccessComponent,
    PaymentCancelComponent,
    InviteSignupComponent,
    PlaylistViewComponent,
    SchoolcoachComponent,
    PlansComponent,
    SeriesComponent,
    SeriesviewComponent
  ],
  imports: [
    BrowserModule, 
    AppRoutingModule, 
    HttpClientModule,
    OwlDateTimeModule, 
    OwlNativeDateTimeModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    DefaultModule,
    AdminModule,
    SharedAdminModule,
    InnerpageModule,
    SeriespageModule,
    SeriesinnerModule,
    SharedModule,
    NgSlimScrollModule,
    StripeCardComponent,
    StripeElementsDirective,
    ToastNoAnimationModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 2000,
      maxOpened: 1,
      progressBar: false,
      enableHtml: true,
    }),
    StoreModule.forRoot({
      user: userReducer,
      adminuser: adminuserReducer,
    }, { metaReducers }),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
    }),
    EffectsModule.forRoot([AppEffect]),
    NgxStripeModule.forRoot()
  ], 
  providers: [
    { 
      provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi:true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
